import React from 'react';
import styles from './LoadingOverlay.module.scss';

export default function LoadingOverlay({ text = 'Загрузка...', inline = false, compact = false }) {
    return (
        <div className={`${styles.overlay} ${inline ? styles.inline : ''} ${compact ? styles.compact : ''}`}>
            <div className={styles.spinner} />
            <div className={styles.text}>{text}</div>
        </div>
    );
}
